// frontend/src/lib/pixWhatsapp.js
//
// Mensagem do WhatsApp para o cliente (ETAPA 6b): o MESMO texto que o Pix antigo usa (compartilharQr.js, montarMensagem).
// Sem emojis (no WhatsApp Desktop eles chegam quebrados quando vêm por link) e com o LINK ANTES do código (o WhatsApp só faz a
// prévia do primeiro link da mensagem).

const hasValue = (v) => v !== undefined && v !== null && v !== '' && !Number.isNaN(Number(v));
const brl = (v) => Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace(/\u00a0/g, ' ');

/** Primeiro nome, com a inicial maiúscula ("MARIA DA SILVA" vira "Maria"). */
export function firstName(name) {
  const first = String(name == null ? '' : name).trim().split(/\s+/)[0] || '';
  if (!first) return '';
  return first === first.toUpperCase() ? first.charAt(0) + first.slice(1).toLowerCase() : first;
}

/**
 * @param {Object} p
 * @param {string} [p.name] nome do cliente.
 * @param {string} [p.description] plano ou descrição da cobrança.
 * @param {number|string} [p.amount] valor em reais.
 * @param {string} [p.code] código Pix copia e cola (ou link de pagamento).
 * @param {string} [p.link] link público do QR (vem antes do código).
 * @param {boolean} [p.automatic] true = Pix Automático (recorrência); false = Pix único (cobrança avulsa).
 */
export function buildWhatsappMessage({ name, description, amount, code, link, automatic = true }) {
  const codigo = String(code || '').trim();
  const isLink = /^https?:\/\//i.test(codigo);
  const desc = String(description || '').trim();
  const short = firstName(name);

  const lines = [short ? `Olá, ${short}!` : 'Olá!', ''];
  if (automatic) {
    lines.push(`Para ativar o *Pix Automático*${desc ? ` (${desc})` : ''}${hasValue(amount) ? `, no valor de ${brl(amount)}` : ''}, faça a autorização pelo app do seu banco:`);
  } else {
    lines.push(`Segue o código Pix para pagamento${desc ? ` de ${desc}` : ''}${hasValue(amount) ? `, no valor de ${brl(amount)}` : ''}:`);
  }
  lines.push('');
  if (!codigo) {
    lines.push('Estou enviando o QR Code em imagem. Leia pelo app do seu banco, em *Pix* > *Ler QR Code*.');
  } else if (link) {
    lines.push(
      'Veja o QR Code e copie o código neste link:', '', link, '',
      isLink ? 'Se preferir, abra o link de pagamento abaixo:' : 'Ou, se preferir, abra o app do seu banco, escolha *Pix* > *Pix Copia e Cola* e cole o código abaixo:',
      '', codigo,
    );
  } else if (isLink) {
    lines.push('Abra o link abaixo para continuar:', '', codigo);
  } else {
    lines.push('1) Abra o app do seu banco', '2) Escolha *Pix* e depois *Pix Copia e Cola* (ou *Ler QR Code*)', '3) Cole o código abaixo e confirme', '', codigo);
  }
  lines.push('', 'Qualquer dúvida, é só responder esta mensagem.');
  return lines.join('\n');
}
